import { Footer, Header, Snackbar, themes } from '@blackbird/ui-base';
import { Theme, ThemeProvider, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';

const styles = (theme: Theme) =>
  createStyles({
    '@global': {
      html: {
        backgroundColor: themes.dark.palette.primary.main,
      },
    },
    ieFlexboxFix: {
      display: 'flex',
      flexDirection: 'column',
    },
    root: {
      flexGrow: 1,
    },
    appFrame: {
      overflowX: 'hidden',
      position: 'relative',
      display: 'flex',
      width: '100%',
      height: '100%',
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 'auto',
    },
    content: {
      width: '100%',
      overflowX: 'hidden',
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      marginTop: 56,
      [theme.breakpoints.up('sm')]: {
        padding: 24,
        marginTop: 64,
      },
    },
    flexibleFooter: {
      minHeight: '100vh',
      flexDirection: 'column',
      display: 'flex',
      flexGrow: 1,
      flexBasis: 'auto',
    },
  });

interface Properties {}

interface State {}

class PageLayout extends React.Component<Properties & WithStyles<typeof styles>, State> {
  render() {
    const { classes, children } = this.props;

    return (
      <Snackbar>
        <div className={classes.ieFlexboxFix}>
          <div className={classes.flexibleFooter}>
            <div className={classes.appFrame}>
              <ThemeProvider theme={themes.dark}>
                <Header isAuthPage={true} />
              </ThemeProvider>
              <div className={classes.content}>{children}</div>
            </div>
            <ThemeProvider theme={themes.dark}>
              <Footer />
            </ThemeProvider>
          </div>
        </div>
      </Snackbar>
    );
  }
}

export default withStyles(styles)(PageLayout);
